import * as types from './types';

const initialState = {
  // UI
  isOpen: false,
  filter: 'all',          // 'all' | 'feature' | 'upgrade'

  // Data
  items: [],              // [{ id, type, title, description, is_premium, published_at, seen, actions }]
  unseenCount: 0,

  // Flags
  isLoadingList: false,
  isLoadingCount: false,
  demoRequestedIds: []    // local set of news IDs the user just requested a demo for
};

const newsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.NEWS_OPEN_DRAWER:
      return { ...state, isOpen: true };

    case types.NEWS_CLOSE_DRAWER:
      return { ...state, isOpen: false };

    case types.NEWS_SET_FILTER:
      return { ...state, filter: action.payload };

    // — Unseen count —
    case types.NEWS_UNSEEN_COUNT_REQUEST:
      return { ...state, isLoadingCount: true };

    case types.NEWS_UNSEEN_COUNT_SUCCESS:
      return { ...state, isLoadingCount: false, unseenCount: action.payload.unseenCount };

    case types.NEWS_UNSEEN_COUNT_ERROR:
      return { ...state, isLoadingCount: false };

    // — List —
    case types.NEWS_LIST_REQUEST:
      return { ...state, isLoadingList: true };

    case types.NEWS_LIST_SUCCESS:
      return {
        ...state,
        isLoadingList: false,
        items: action.payload.items,
        unseenCount: action.payload.unseenCount
      };

    case types.NEWS_LIST_ERROR:
      return { ...state, isLoadingList: false };

    // — Mark seen (viewport) —
    case types.NEWS_MARK_SEEN_SUCCESS: {
      const seenSet = new Set(action.payload.seenIds);
      return {
        ...state,
        unseenCount: action.payload.unseenCount,
        items: state.items.map((item) =>
          seenSet.has(item.id) ? { ...item, seen: true } : item
        )
      };
    }

    // — Interactions —
    case types.NEWS_INTERACTION_SUCCESS:
      if (action.payload.actionType === 'demo') {
        return {
          ...state,
          demoRequestedIds: state.demoRequestedIds.indexOf(action.payload.newsId) === -1
            ? [...state.demoRequestedIds, action.payload.newsId]
            : state.demoRequestedIds
        };
      }
      return state;

    default:
      return state;
  }
};

export default newsReducer;



// WEBPACK FOOTER //
// ./src/components/news/store/reducer.js